export default __webpack_public_path__ + "images/LVOT.8a346cbdab617ed7cfc37f52da33b0f0.png";